// src/admin/components/payments/PrintReceipt.jsx
import React, { useRef, useState, useEffect } from 'react';
import {
  RiPrinterLine,
  RiCloseLine,
  RiTranslate2,
  RiDownloadLine
} from 'react-icons/ri';
import { formatCurrency, formatPaymentDate } from '../../../models/paymentModel';
import { getUserProfile } from '../../../models/userModel';
import api from '../../../services/api';
import UnifiedReceipt from '../shared/UnifiedReceipt';

const PrintReceipt = ({ payment, type = 'rent', onClose, companyInfo = {}, autoPrint = false }) => {
  const [isRTL, setIsRTL] = useState(payment.isRTL || false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [orgSettings, setOrgSettings] = useState(null);
  const printContentRef = useRef(null);

  // Fetch current user on component mount
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const { user } = await getUserProfile();
        setCurrentUser(user);
      } catch (error) {
        console.error('Failed to fetch user profile:', error);
      }
    };

    const fetchOrgSettings = async () => {
      try {
        const response = await api.get('/organization/settings');
        if (response.data && response.data.success) {
          setOrgSettings(response.data.organization);
        }
      } catch (error) {
        console.error('Failed to fetch organization settings:', error);
      }
    };

    fetchUserProfile();
    fetchOrgSettings();

    // Auto-print if the prop is true and payment is loaded
    if (autoPrint && payment) {
      const timer = setTimeout(() => {
        handlePrint();
      }, 500); // Shorter delay to avoid popup blockers
      return () => clearTimeout(timer);
    }
  }, [autoPrint, payment]);

  if (!payment || !orgSettings) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
        <div className="bg-white p-6 rounded-lg shadow-lg flex items-center space-x-3">
          <div className="animate-spin h-5 w-5 border-2 border-teal-500 border-t-transparent rounded-full"></div>
          <span>Loading receipt...</span>
        </div>
      </div>
    );
  }

  return (
    <UnifiedReceipt
      data={payment}
      type={type}
      branding={{
        logoUrl: orgSettings.logoUrl,
        companyName: orgSettings.name,
        contactEmail: orgSettings.contactEmail,
        contactPhone: orgSettings.contactPhone,
        address: orgSettings.address
      }}
      onClose={onClose}
      autoPrint={autoPrint}
    />
  );
};

export default PrintReceipt;